/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import omit from 'lodash/fp/omit.js';
import {
  START_CREATE_MODEL_FLOW,
  CHOOSE_UPLOAD_REPORT,
  END_CREATE_MODEL_FLOW,
  LEAVE_CREATE_MODEL_FLOW_STEP,
} from '#constants/actionTypes.js';

const initialState = {};

/*
 * Ephemeral, in-memory tracking of where an already-created model sits within the create flow's
 * decision/upload interstitial (HBR-4950 #316 decisions 3/4) -- deliberately NOT persisted (see
 * ui/src/js/store/index.js), so a refresh or deep link loses the step and the routing guard
 * (RequireCreateModelFlowStep) redirects to the model instead of re-rendering either step.
 */
const createModelFlowReducer = (state = initialState, action = {}) => {
  const { type, meta } = action;
  const modelId = meta && meta.modelId;
  if (!modelId) {
    return state;
  }
  switch (type) {
    case START_CREATE_MODEL_FLOW:
      return { ...state, [modelId]: 'decide' };
    case CHOOSE_UPLOAD_REPORT:
      return { ...state, [modelId]: 'upload' };
    case END_CREATE_MODEL_FLOW:
      return omit([modelId], state);
    case LEAVE_CREATE_MODEL_FLOW_STEP:
      // Only clear the step the leaving component actually rendered: if it has already moved on
      // to a later step (e.g. decide -> upload), this is a stale cleanup and must be a no-op, or
      // it would erase the step the flow just advanced to (Copilot finding on PR #344).
      return state[modelId] === meta.step ? omit([modelId], state) : state;
    default:
      return state;
  }
};

export default createModelFlowReducer;
